<template>
  <!-- COSTS Section -->
  <div class="costs-section">
    <div class="title-container">
      <span class="title">Costs</span>
      <InfoIcon :infoData="infoDetails['wr_costs']"/>
    </div>

    <div class="content-container">
      <div class="column-container">
        <ThemedColumnText topText="ECA Fuel" :bottomText="ecaFuelText" />
        <ThemedColumnText topText="nonECA Fuel" :bottomText="nonEcaFuelText" />
      </div>
      <div class="column-container">
        <ThemedColumnText topText="Daily Rate" :bottomText="dailyCostsText" />
      </div>
    </div>
  </div>
</template>
  
  <script>
import ThemedColumnText from "@/core/ThemedColumnText.vue";
import InfoIcon from "@/core/InfoIcon.vue";

import { mapState } from "vuex";
export default {
  components: { ThemedColumnText, InfoIcon },
  computed: {
    ...mapState("main", ["infoDetails"]),
    ...mapState("weatherRouting/formModule", [
      "ecaFuelPrice",
      "nonEcaFuelPrice",
      "dailyCosts",
      "ecaFuelEnergy",
      "nonEcaFuelEnergy",
    ]),
    ecaFuelText() {
      return `${this.ecaFuelPrice} US$/mt (${this.ecaFuelEnergy} MJ/kg)`;
    },
    nonEcaFuelText() {
      return `${this.nonEcaFuelPrice} US$/mt (${this.nonEcaFuelEnergy} MJ/kg)`;
    },
    dailyCostsText() {
      return `${this.dailyCosts} US$/day`;
    },
  },
  name: "ExtraVoyageSettings",
};
</script>
  
  <style scoped>
.costs-section {
  background-color: var(--color-bg);
  padding: 10px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
}
.title-container {
  display: flex;
  align-items: center;
}
.content-container {
  background-color: var(--color-bg);
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.column-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>

